import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
//import DrillDown from './drilldown/DrillDown';
import { MiniDrawer } from "./components/layouts";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { AuthRoute } from "react-router-auth";
//test checking

import {
  SignIn,
  SignUp,
  Forgot,
  RequestMail,
  NotFoundView,
  Newdevice,
} from "./components/pages";
import ServerMaintance from "./components/pages/ServerMaintance/ServerMaintance"
import PrivateRoute from "./components/services/PrivateRoute";
import { useSelector, useDispatch } from 'react-redux';
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  pageLoading: {
    position: "fixed",
    width: "100%",
    height: "100%",
    background: "#1e1b1bb5",
    zIndex: 9999,
    top: "0px",
    color: "#fff"
  }

}));
export default function Routes() {
  const classes = useStyles();
  const [authenticated, setAuthenticated] = useState(true);
  const loading = useSelector(state => state.RootReducer);

  useEffect(() => {}, []);
  return (
    <React.Fragment>
    {process.env.REACT_APP_UNDERMAINTANANCE=="true"?<><Switch><Route path="*" component={ServerMaintance} /></Switch></>:<><Switch>
      <PrivateRoute path="/dashboard" component={MiniDrawer} />
      <PrivateRoute path="/sign-in" component={SignIn} pagename={"signin"} />
      <PrivateRoute path="/sign-up" component={SignUp} pagename={"signup"} />
      <PrivateRoute path="/forgot" component={Forgot} pagename={"forgot"} />
      <PrivateRoute path="/newdevice/:email" component={Newdevice} pagename={"newdevice"} />
      <PrivateRoute path="/request-sent" component={RequestMail}  pagename={"requestsent"} />
      <PrivateRoute path="/ServerMaintance" component={ServerMaintance} pagename={"ServerMaintance"} />
      <PrivateRoute path="/" pagename={"signin"}  component={SignIn} />
      <Route path="*" component={NotFoundView} />
    </Switch></>}
    <Box className={classes.pageLoading} style={{ display: loading.padeLoad ? "block" : "none" }}>
        <Box my={5} display="flex" alignItems="center" height={1} justifyContent="center">
          <Box component="img" src={
            process.env.REACT_APP_CUSTOMER_PORTAL_URL +
            "assets/svg/loading.svg"
          } />
        </Box>
      </Box>
    </React.Fragment>
  );
}
